import { Component, computed, input, ViewEncapsulation } from '@angular/core';
import { linkifyToHtml } from './linkify.util';

/**
 * Read-only view for instructor free text: URLs render as clickable links and line breaks
 * are preserved. Content is stored and edited as plain text — this only affects display.
 *
 * The generated HTML is escaped at the source (see `linkifyToHtml`) and passes through
 * Angular's `[innerHTML]` sanitizer as a second layer. Never swap this for
 * `bypassSecurityTrustHtml`.
 *
 * Encapsulation is None deliberately. Anchors are injected by `[innerHTML]` at runtime, so
 * they never receive the `_ngcontent` attribute that emulated encapsulation scopes styles
 * with — under the default, every `a` rule in the stylesheet silently matches nothing.
 * `chat-message` opts out for the same reason. All rules stay nested under `.rich-text-view`
 * so nothing leaks.
 *
 * Callers keep their own empty states: blank content renders nothing.
 *
 * Usage:
 *   <lb-rich-text-view [content]="summary()" />
 */
@Component({
	selector: 'lb-rich-text-view',
	template: `<div class="rich-text-view" [innerHTML]="html()"></div>`,
	styleUrl: './rich-text-view.component.scss',
	standalone: true,
	encapsulation: ViewEncapsulation.None
})
export class RichTextViewComponent {
	readonly content = input<string | null | undefined>('');

	readonly html = computed(() => linkifyToHtml(this.content()));
}
